
export async function downloadFile(url) {
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function (event) {
            var blob = xhr.response;
            resolve(blob);
        };
        xhr.open('GET', url);
        xhr.send();
    })

    // return new File([url], url);
}